// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"users-list_wrapper__ggyae","tableHeader":"users-list_tableHeader__2wUmz","addBtn":"users-list_addBtn__3CuYo","addBtnText":"users-list_addBtnText__2MlBV"};